import { render, staticRenderFns } from "./IcaurKOC.vue?vue&type=template&id=f5739a48&scoped=true"
import script from "./IcaurKOC.vue?vue&type=script&lang=js"
export * from "./IcaurKOC.vue?vue&type=script&lang=js"
import style0 from "./IcaurKOC.vue?vue&type=style&index=0&id=f5739a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5739a48",
  null
  
)

export default component.exports